/* eslint-disable prettier/prettier */
const StorageService = {
	// Create or Update
	set<T>(key: string, value: T): void {
		try {
			const serializedValue = JSON.stringify(value);
			localStorage.setItem(key, serializedValue);
		} catch (error) {
			console.error(`Error storing item with key "${key}":`, error);
		}
	},

	// Read
	get<T>(key: string, defaultValue: T): T {
		try {
			const serializedValue = localStorage.getItem(key);
			if (serializedValue === null) {
				return defaultValue;
			}
			return JSON.parse(serializedValue);
		} catch (error) {
			console.error(`Error retrieving item with key "${key}":`, error);
			return defaultValue;
		}
	},

	// Delete
	remove(key: string): void {
		try {
			localStorage.removeItem(key);
		} catch (error) {
			console.error(`Error removing item with key "${key}":`, error);
		}
	},

	// Clear all
	clear(): void {
		try {
			localStorage.clear();
		} catch (error) {
			console.error('Error clearing storage:', error);
		}
	},

	// Check if key exists
	exists(key: string): boolean {
		return localStorage.getItem(key) !== null;
	},
};

export default StorageService;
